import {ForgotPasswordComponent} from "./forgot-password.component";

export default ForgotPasswordComponent
